
export abstract class BaseLocationBuilder {
    protected buildPathsToCall(paths: string[]) {
        const pathResult = [];
        paths.reduce((acc, current) => {
            const path = `${acc}${!current ? "" : "/"}${current}`;
            pathResult.push(path);
            return path;
        }, "");

        return pathResult;
    }
}
